// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"4c3f2ae1","513":"cfbefca4","787":"d3c96436"}[chunkId] + ".chunk.js";
};